import { TYPE_STRING } from './input-types';

export const id = 'notesToBuyer';
export const apiKey = 'NotesToBuyer';
export const type = TYPE_STRING;

export const notesToBuyer = {
  id,
  apiKey,
  type,
};
